// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_k5-0";
export var animationContainer = "_k5-1";
export var itemPrice = "_k5-a";
export var itemizedContent = "_k5-9";
export var itemizedHeader = "_k5-7";
export var itemizedRow = "_k5-8";
export var itemizedSection = "_k5-6";
export var modalContent = "_k5-2";
export var orderName = "_k5-3";
export var refundOption = "_k5-4";
export var refundOptionsContainer = "_k5-5";
export var shippingLabel = "_k5-b";
export var totalRow = "_k5-c";